import React from 'react'
import { Document, Page, View, Text, Image, StyleSheet } from '@react-pdf/renderer'
import { satisfaccion_2_catalog } from '../../../../escalas/satisfaccion_2/satisfaccion_2.catalog'
import { IMAGE_API, myHospitals } from '../../../../resources'

const respuestas_radio = ["Completamente en desacuerdo", "En desacuerdo", "Neutral", "De acuerdo", "Totalmente de acuerdo"]

function getRespuesta(item, resp) {
    if (item.tipo === 'radioButton') return respuestas_radio[resp]
    return resp
}

const styles = StyleSheet.create({
    page: {
        padding: 32,
        fontSize: 10,
        fontFamily: 'Helvetica',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 16,
    },
    logo: {
        width: 80,
        height: 50,
        objectFit: 'contain',
    },
    headerRight: {
        textAlign: 'right',
        alignItems: 'flex-end',
    },
    title: {
        fontSize: 14,
        fontWeight: 700,
        color: '#505050',
    },
    subtitle: {
        fontSize: 10,
        marginTop: 2,
        color: '#505050',
    },
    infoRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 12,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 6,
        borderRadius: 4,
    },
    rowEven: {
        backgroundColor: '#f5f5f5',
    },
    question: {
        width: '70%',
    },
    answer: {
        width: '28%',
        textAlign: 'right',
    },
})

export default function SatisfaccionPDF({ pacienteData, fecha, satisfaccion = [] }) {
    return (
        <Document>
            <Page size="LETTER" style={styles.page}>
                <View style={styles.header}>
                    <Image src={IMAGE_API + myHospitals[0]?.logo} style={styles.logo} />
                    <View style={styles.headerRight}>
                        <Text style={styles.title}>Encuesta de Satisfacción</Text>
                        {fecha && <Text style={styles.subtitle}>{new Date(fecha).toLocaleDateString('es-MX')}</Text>}
                    </View>
                </View>

                <View style={styles.infoRow}>
                    <Text>Paciente: {pacienteData?.name || '-'}</Text>
                </View>

                {
                    satisfaccion_2_catalog.map((item, index) => (
                        <View key={index} style={index % 2 === 0 ? [styles.row, styles.rowEven] : styles.row}>
                            <Text style={styles.question}>{item.label}</Text>
                            <Text style={styles.answer}>{getRespuesta(item, satisfaccion[index])}</Text>
                        </View>
                    ))
                }
            </Page>
        </Document>
    )
}
